<template>
  <SysDialog
    v-model="dialog_ativo"
    content-class="b-radius-15px"
    largura="550"
    ocultar_botao_fechar
  >
    <template #ativador>
      <v-btn icon @click="mudarEstadoDialog">
        <v-icon>mdi-plus-box-multiple</v-icon>
      </v-btn>
    </template>

    <template #titulo>
      <div class="d-flex">
        <v-btn icon class="ml-n2 mr-3" @click="mudarEstadoDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="ml-3">
          <p class="ma-0">Consolidar carrinhos</p>
          <p class="ma-0 mt-n2 font-12 font-weight-regular">Selecione os fornecedores para análise em apenas um carrinho</p>
        </div>
      </div>
    </template>

    <template #default>
      <v-data-table
        v-model="fornecedores_selecionados"
        :headers="cabecalhos"
        :items="fornecedores"
        item-key="id_fornecedor"
        show-select
        hide-default-footer
        :items-per-page="-1"
        class="mt-n3 ml-4 font-resp-tabela"
        height="calc(100vh - 300px)"
      />
    </template>

    <template #actions>
      <v-btn text color="primary" @click="consolidarPedidos">
        confirmar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "../../../padraoDeLayout/SysDialog";
import FornecedorAPI from "../../../../api/fornecedor.js";
import CarrinhoAPI from "../../../../api/carrinho.js";
import {arrayColumn, logout} from "../../../../helpers";
import {mapGetters} from "vuex";

export default {
  name: "ConsolidaPedidosFornecedores",
  components: {
    SysDialog
  },
  props: {
    pedidos: Array
  },
  data: () => ({
    dialog_ativo:  false,
    fornecedores: [],
    fornecedores_selecionados: [],
    cabecalhos: [
      {text: "Id", value: "id_fornecedor"},
      {text: "Nome fornecedor", value: "razao_social"}
    ],
    carregando_dados: false
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      fornecedorCompra: "fornecedor/getFornecedor"
    }),
  },
  watch: {
    dialog_ativo() {
      this.buscarFornecedoresGrupo();
    }
  },
  methods: {
    buscarFornecedoresGrupo() {
      if (this.fornecedores.length > 0) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        FornecedorAPI.buscarGrupoAnalise(this.fornecedorCompra.id)
          .then(resposta => {
            const {token, grupo} = resposta.data;
            localStorage.token = token;
            this.fornecedores = grupo.fornecedores;
            this.fornecedores_selecionados = this.fornecedores
              .filter(fornecedor => !this.pedidos.find(pedido => (!pedido.grupo_analise_fornecedor && pedido.idfornecedor == fornecedor.id_fornecedor)))
          })
          .catch(() => logout())
      );
    },
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;
    },
    consolidarPedidos() {
      const parametros = {
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        grupo_analise: this.fornecedorCompra.id,
        fornecedores: arrayColumn(this.fornecedores_selecionados, "id_fornecedor"),
        analiseGrupoFornecedores: 'S',
        compra_por_filial: this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'] ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.consolidarCarrinhosFornecedores(parametros)
          .then(resposta => {
            localStorage.token = resposta.data.token;
            this.$emit("pedidos-consolidados", this.pedidos_selecionados);
            this.dialog_ativo = false;
          })
          .catch(() => logout())
      );
    }
  }
}
</script>

<style scoped>

</style>
